import { lightTheme } from '@/customTheme'
import GradientButton from '@/components/GradientButton/GradientButton'
import React from 'react'

interface Props {
  eyebrow?: string
  title: string
  buttonLabel: string
  onButtonClick: () => void
  buttonIcon?: JSX.Element
}

function ModalCTAPanel({ eyebrow, title, buttonLabel, onButtonClick, buttonIcon }: Props) {
  return (
    <div
      style={{
        width: '460px',
        background: '#fff',
        position: 'relative',
        flexShrink: 0,
      }}
    >
      <div
        style={{
          position: 'absolute',
          top: '50%',
          transform: 'translateY(-50%)',
          left: '48px',
          width: '364px',
          display: 'flex',
          flexDirection: 'column',
          gap: '32px',
        }}
      >
        {/* Text block */}
        <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
          {eyebrow && (
            <p style={{ ...lightTheme.typography.Small16Bold, margin: 0, color: lightTheme.colors.blackGray }}>
              {eyebrow}
            </p>
          )}
          <h2
            style={{
              ...lightTheme.typography.Title34Bold,
              margin: 0,
              color: lightTheme.colors.blackGray,
            }}
          >
            {title}
          </h2>
        </div>

        {/* CTA button */}
        <GradientButton onClick={onButtonClick} startEnhancer={buttonIcon}>
          {buttonLabel}
        </GradientButton>
      </div>
    </div>
  )
}

export default ModalCTAPanel
